<template lang="pug">
div
  text-field.mr-0(
    label='Product naam',
    v-model='data.productName'
    )

  text-field.mr-0(
    label='Product link',
    v-model='data.productLink'
    )

  //- Product Type specifics below
  text-field.mr-0(
    v-if='productType === "car" || productType === "motorcycle"'
    label='Kenteken',
    v-model='data.licensePlate'
    )
</template>

<script>
export default {
  props: {
    value: Object,
    productType: String
  },

  data () {
    return {
      data: this.value
    }
  },

  watch: {
    'value': {
      handler: function (v) {
        this.data = v
      },
      deep: true,
      immediate: true
    },

    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
